(() => {
  if (window.__jelriWizzZeroLineCleaner20260623 || typeof window.fetch !== "function") return;
  window.__jelriWizzZeroLineCleaner20260623 = true;

  const state = {
    inFlightCart: null,
    lastCart: null,
    lastReadAt: 0
  };

  const originalFetch = window.fetch.bind(window);
  const rewardThreshold = 2;

  function normalizeCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return { items: [], item_count: 0 };
    if (typeof cart.item_count !== "number") {
      cart.item_count = cart.items.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    }
    return cart;
  }

  function moneyFormat(cents) {
    try {
      return new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" })
        .format(Number(cents || 0) / 100)
        .replace("$", "MXN ");
    } catch (error) {
      return "MXN " + (Number(cents || 0) / 100).toFixed(2);
    }
  }

  function recordError(error) {
    window.__jelriWizzZeroLineCleanerErrors = window.__jelriWizzZeroLineCleanerErrors || [];
    window.__jelriWizzZeroLineCleanerErrors.push({
      message: error && error.message ? error.message : String(error),
      at: new Date().toISOString()
    });
  }

  async function readCanonicalCart() {
    if (state.inFlightCart) return state.inFlightCart;
    if (state.lastCart && Date.now() - state.lastReadAt < 650) return state.lastCart;

    state.inFlightCart = originalFetch("/cart.js", { headers: { "accept": "application/json" } })
      .then((response) => {
        if (!response.ok || response.headers.get("content-type")?.includes("text/html")) {
          throw new Error("Cart read failed: " + response.status);
        }
        return response.json();
      })
      .then((cart) => {
        const normalized = normalizeCart(cart);
        state.lastCart = normalized;
        state.lastReadAt = Date.now();
        return normalized;
      })
      .finally(() => {
        state.inFlightCart = null;
      });

    return state.inFlightCart;
  }

  function getLineQuantity(productLine) {
    const input = productLine && productLine.querySelector(".wizz-product-content-buttonGroup-custom input, input");
    const quantity = Number(input && input.value);
    return Number.isFinite(quantity) ? quantity : null;
  }

  function getLineVariantId(productLine) {
    const variantLink = productLine && productLine.querySelector('a[href*="variant="]');
    if (!variantLink) return null;

    try {
      const url = new URL(variantLink.getAttribute("href"), window.location.href);
      const variant = Number(url.searchParams.get("variant"));
      return Number.isFinite(variant) ? variant : null;
    } catch (error) {
      return null;
    }
  }

  function findCartItemForLine(cart, productLine, lineIndex) {
    if (!cart || !Array.isArray(cart.items) || !productLine) return null;

    const variantId = getLineVariantId(productLine);
    if (variantId) {
      const item = cart.items.find((cartItem) => Number(cartItem.id || cartItem.variant_id) === variantId);
      if (item) return item;
    }

    return cart.items[lineIndex] || null;
  }

  function hideLine(productLine) {
    if (!productLine) return;
    if (typeof productLine.dataset.jelriOriginalDisplay === "undefined") {
      productLine.dataset.jelriOriginalDisplay = productLine.style.display || "";
    }
    if (!productLine.dataset.jelriZeroSeenAt) {
      productLine.dataset.jelriZeroSeenAt = String(Date.now());
    }
    productLine.dataset.jelriPendingRemove = "true";
    productLine.style.display = "none";
  }

  function restoreLine(productLine) {
    if (!productLine || productLine.dataset.jelriPendingRemove !== "true") return;
    productLine.style.display = productLine.dataset.jelriOriginalDisplay || "";
    delete productLine.dataset.jelriPendingRemove;
    delete productLine.dataset.jelriOriginalDisplay;
    delete productLine.dataset.jelriZeroSeenAt;
  }

  function updateHeaderCount(count) {
    document.querySelectorAll("[data-cart-count]").forEach((node) => {
      node.setAttribute("data-cart-count", String(count));
      if (/^\s*\d+\s*$/.test(node.textContent || "")) node.textContent = String(count);
    });

    if (window.themeCore && window.themeCore.EventBus) {
      window.themeCore.EventBus.emit("header:update-item-count", { item_count: count });
    }
  }

  function updateRewardBar(cart, drawer) {
    if (!cart || !drawer) return;

    const count = Math.max(0, Number(cart.item_count || 0));
    const remaining = Math.max(0, rewardThreshold - count);
    const progress = Math.max(0, Math.min(100, count / rewardThreshold * 100));
    const titleText = remaining === 0
      ? "🎉 ¡Felicidades! Has obtenido envío gratis 🚚"
      : "Estás a " + remaining + " de obtener un descuento de envío gratuito.";

    drawer.querySelectorAll(".wizz-rewardbar-title").forEach((node) => {
      if (node.textContent !== titleText) node.textContent = titleText;
    });
    drawer.querySelectorAll(".wizz-rewardbar-progress").forEach((node) => {
      node.style.width = progress + "%";
    });
    drawer.querySelectorAll(".wizz-rewardbar-description").forEach((node) => {
      if (node.textContent.trim() !== "Envío Gratis") node.textContent = "Envío Gratis";
    });
  }

  function cartDiscountTotal(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    const lineDiscount = cart.items.reduce((sum, item) => sum + Number(item.total_discount || 0), 0);
    const cartLevel = Number(cart.total_discount || 0);
    const originalDelta = Math.max(0, Number(cart.original_total_price || 0) - Number(cart.total_price || 0));
    return Math.max(lineDiscount, cartLevel, originalDelta);
  }

  function syncDiscountTotals(cart, drawer) {
    if (!cart || !drawer) return;
    const discount = cartDiscountTotal(cart);
    const formatted = moneyFormat(discount);
    drawer.querySelectorAll(".wizz-checkout-discounts-price, .wizz-checkout-total-discounts-price").forEach((node) => {
      node.textContent = formatted;
    });
  }

  function syncProductLine(productLine, item) {
    if (!productLine || !item) return;

    const quantity = Math.max(0, Number(item.quantity || 0));
    const input = productLine.querySelector(".wizz-product-content-buttonGroup-custom input, input");
    if (input && input.value !== String(quantity)) input.value = String(quantity);

    const originalLinePrice = Number(item.original_line_price || item.line_price || 0);
    const finalLinePrice = Number(item.final_line_price || item.line_price || 0);
    const saving = Math.max(0, originalLinePrice - finalLinePrice);

    productLine.querySelectorAll(".wizz-product-price-originalPrice-custom").forEach((node) => {
      node.textContent = moneyFormat(originalLinePrice);
    });
    productLine.querySelectorAll(".wizz-product-price-Price-custom").forEach((node) => {
      node.textContent = moneyFormat(finalLinePrice);
    });
    productLine.querySelectorAll(".wizz-product-price-saving-custom").forEach((node) => {
      node.textContent = saving > 0 ? "Guardar " + moneyFormat(saving) : "";
    });
  }

  function syncProductLines(cart, drawer) {
    if (!cart || !drawer) return;
    const productLines = Array.from(drawer.querySelectorAll(".wizz-product-custom"));

    productLines.forEach((productLine, lineIndex) => {
      const item = findCartItemForLine(cart, productLine, lineIndex);
      if (!item || Number(item.quantity || 0) <= 0) {
        productLine.remove();
        return;
      }

      if (productLine.dataset.jelriPendingRemove === "true") return;
      syncProductLine(productLine, item);
      restoreLine(productLine);
    });
  }

  function checkoutButtonLabel(cart) {
    return "Finalizar compra - " + moneyFormat(cart.total_price || cart.items_subtotal_price);
  }

  function ensureCheckoutButton(link) {
    if (!link) return null;

    let button = link.querySelector(".wizz-checkout-button");
    if (button) return button;

    link.textContent = "";
    button = document.createElement("button");
    button.type = "button";
    button.className = "wizz-checkout-button w4-bg-[#303030] w4-cursor-pointer w4-text-white w4-py-[16px] w4-px-[28px] w4-gap-[32px] w4-h-[52px] w4-w-full w4-flex w4-justify-center w4-items-center w4-font-[550] w4-text-[13px]";
    button.addEventListener("click", () => {
      window.location.href = link.getAttribute("href") || "/checkout";
    });
    link.appendChild(button);
    return button;
  }

  function setCheckoutButtonText(button, label) {
    if (!button) return;
    const content = button.querySelector(".w4-flex, span, div");
    if (content) {
      content.textContent = label;
      return;
    }

    button.textContent = label;
  }

  function syncCheckoutButtons(cart, drawer) {
    if (!cart || !drawer) return;
    const label = checkoutButtonLabel(cart);
    const links = Array.from(drawer.querySelectorAll(".wizz-checkout-link"));

    links.forEach((link) => {
      if (!link.getAttribute("href")) link.setAttribute("href", "/checkout");
      const button = ensureCheckoutButton(link);
      setCheckoutButtonText(button, label);
    });

    drawer.querySelectorAll(".wizz-checkout-button").forEach((button) => {
      if (button.closest(".wizz-checkout-link")) return;
      setCheckoutButtonText(button, label);
    });
  }

  function syncDrawerTotals(cart, drawer) {
    if (!cart || !drawer) return;

    drawer.querySelectorAll(".wizz-header-title-custom").forEach((title) => {
      if (title.textContent && /\(\s*\d+\s*\)/.test(title.textContent)) {
        title.textContent = title.textContent.replace(/\(\s*\d+\s*\)/, "(" + cart.item_count + ")");
      }
    });

    syncCheckoutButtons(cart, drawer);

    updateHeaderCount(cart.item_count);
    updateRewardBar(cart, drawer);
    syncDiscountTotals(cart, drawer);
    syncProductLines(cart, drawer);
  }

  async function syncVisibleCart(cart) {
    const drawers = Array.from(document.querySelectorAll(".wizz4-cart-drawer.wizz4-visible, .wizz4-cart-drawer"));
    if (!drawers.length) return;

    let canonicalCart = cart && Array.isArray(cart.items) ? normalizeCart(cart) : null;
    if (!canonicalCart) {
      try {
        canonicalCart = await readCanonicalCart();
      } catch (error) {
        recordError(error);
        return;
      }
    }

    drawers.forEach((drawer) => syncDrawerTotals(canonicalCart, drawer));
  }

  function scheduleCartSync(cart, delays = [900, 2400]) {
    delays.forEach((delayMs) => {
      window.setTimeout(() => syncVisibleCart(cart), delayMs);
    });
  }

  async function cleanupZeroLines(cart) {
    const drawers = Array.from(document.querySelectorAll(".wizz4-cart-drawer"));
    const zeroLines = drawers.flatMap((drawer) => (
      Array.from(drawer.querySelectorAll(".wizz-product-custom"))
        .filter((productLine) => getLineQuantity(productLine) === 0)
        .map((productLine) => ({ drawer, productLine }))
    ));

    if (!zeroLines.length) return;
    zeroLines.forEach(({ productLine }) => hideLine(productLine));

    let canonicalCart = cart && Array.isArray(cart.items) ? normalizeCart(cart) : null;
    if (!canonicalCart) {
      try {
        canonicalCart = await readCanonicalCart();
      } catch (error) {
        recordError(error);
        scheduleCleanup(null, [900, 2200]);
        return;
      }
    }

    const allLines = Array.from(document.querySelectorAll(".wizz4-cart-drawer .wizz-product-custom"));
    zeroLines.forEach(({ drawer, productLine }) => {
      const lineIndex = allLines.indexOf(productLine);
      const item = findCartItemForLine(canonicalCart, productLine, lineIndex);
      const quantity = Math.max(0, Number(item && item.quantity || 0));
      const input = productLine.querySelector(".wizz-product-content-buttonGroup-custom input, input");

      if (item && quantity > 0) {
        const zeroSeenAt = Number(productLine.dataset.jelriZeroSeenAt || Date.now());
        if (Date.now() - zeroSeenAt < 3500) {
          hideLine(productLine);
          scheduleCleanup(null, [700, 1800, 3200]);
          syncDrawerTotals(canonicalCart, drawer);
          return;
        }

        if (input) input.value = String(quantity);
        restoreLine(productLine);
        syncDrawerTotals(canonicalCart, drawer);
        return;
      }

      delete productLine.dataset.jelriZeroSeenAt;
      productLine.remove();
      syncDrawerTotals(canonicalCart, drawer);
    });

    document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: canonicalCart } }));
  }

  function scheduleCleanup(cart, delays = [0, 160, 520, 1200, 2600]) {
    delays.forEach((delayMs) => {
      window.setTimeout(() => cleanupZeroLines(cart), delayMs);
    });
  }

  document.addEventListener("click", (event) => {
    if (event.target.closest(".wizz-product-content-buttonGroup-decr-custom, .wizz-product-content-buttonGroup-incr-custom")) {
      scheduleCleanup(null, [120, 420, 1000, 1800, 3200]);
      scheduleCartSync(null, [900, 2400]);
    } else if (event.target.closest(".header__icon--cart")) {
      scheduleCleanup(null, [700, 1400]);
      scheduleCartSync(null, [1000, 2600]);
    }
  }, true);

  document.addEventListener("cart:updated", (event) => {
    const cart = event.detail && event.detail.cart;
    scheduleCleanup(cart, [0, 220]);
    scheduleCartSync(cart, [80, 700]);
  });
  window.addEventListener("cart_changed", () => {
    scheduleCleanup(null, [180, 700, 1600]);
    scheduleCartSync(null, [1200, 3000]);
  });

  new MutationObserver((mutations) => {
    const shouldCheck = mutations.some((mutation) => {
      const nodes = [mutation.target, ...mutation.addedNodes];
      return nodes.some((node) => node && node.nodeType === 1 && (
        node.matches?.(".wizz4-cart-drawer, .wizz-product-custom, .wizz-product-content-buttonGroup-custom") ||
        node.querySelector?.(".wizz-product-custom, .wizz-product-content-buttonGroup-custom")
      ));
    });

    if (shouldCheck) scheduleCleanup(null, [0, 500]);
  }).observe(document.documentElement, {
    childList: true,
    attributes: true,
    attributeFilter: ["value", "style", "class", "data-jelri-pending-remove"],
    subtree: true
  });

  window.setInterval(() => {
    if (document.querySelector(".wizz4-cart-drawer.wizz4-visible")) cleanupZeroLines(null);
  }, 1000);

  scheduleCleanup(null, [1200]);
  scheduleCartSync(null, [1800]);
})();
